import axios from "axios";

export const fetchHomeBannersData = (token, page) => async (dispatch) => {
  dispatch({ type: "FETCH_HOME_BANNER_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getAllHomeBanners?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: "FETCH_HOME_BANNER_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_HOME_BANNER_FAILURE",
      payload: error.message,
    });
  }
};
